import { render, staticRenderFns } from "./ProductStockTableCell.vue?vue&type=template&id=707a6ffa&"
import script from "./ProductStockTableCell.vue?vue&type=script&lang=js&"
export * from "./ProductStockTableCell.vue?vue&type=script&lang=js&"
import style0 from "./ProductStockTableCell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports